module.exports = __webpack_public_path__ + "img/中心概括动物房.7e8c3518.png";